import apiKeysItems from './apiKeysItems';

export default [
  {
    header: 'sidebar.general',
    iconName: 'List',
    children: [...apiKeysItems]
  },
  ...apiKeysItems
];
